<template>
  <unlayer
    :min-height="minHeight"
    :project-id="projectId"
    :display-mode="displayMode"
    :custom-c-s-s="customCSS"
    :merge-tags="mergeTags"
    :tabs="tabs"
    :tools="tools"
    :user="user"
    :background-color="design && design.body && design.body.values && design.body.values.backgroundColor ? design.body.values.backgroundColor : '#fff'"
    :fonts="fonts"
    ref="builderEditor"
    class="unlayer"
    @load="editorLoaded"
    @ready="editorReady"
    @update:design="$emit('updated')"
  />
</template>

<script>
import Unlayer from './Unlayer.vue';
import unlayerStyles from '!!raw-loader!sass-loader!./styles/unlayer.scss';
import {addPaddingsForParagraphs} from './utils/addPaddingsForParagraphs.js';
import {makeImagesFitWrapper} from './utils/makeImagesFitWrapper.js';
import { addFonts } from "./utils/addFonts.js";
import {unlayerTools} from './unlayerTools';
import {unlayerTabs} from './unlayerTabs';

export default {
  name: 'SharedStepEditorUnlayer',
  props: {
    design: Object,
    displayMode: String,
    user: Object,
    forceSave: Boolean,
    preview: Boolean,
    mergeTags: Object,
    fonts: Array,
  },
  components: {
    Unlayer,
  },
  data() {
    return {
      minHeight: '500px',
      projectId: 55022,
      customCSS: [unlayerStyles],
      tabs: unlayerTabs,
      tools: unlayerTools,
    };
  },
  methods: {
    editorLoaded() {
      this.$refs?.builderEditor?.editor.loadDesign(this.design);
    },
    exportHtml() {
      this.$refs?.builderEditor?.editor.exportHtml(data => {
        const {design, html, chunks} = data;
        let newHtml = html;
        newHtml = makeImagesFitWrapper(newHtml);
        newHtml = this.displayMode === 'email' ? addPaddingsForParagraphs(newHtml) : newHtml;
        newHtml = addFonts(newHtml, chunks);
        this.$emit('save', {html: newHtml, design});
      });
    },
    editorReady() {
      this.$emit('ready');
    },
  },
  watch: {
    forceSave(val) {
      if (val) {
        this.exportHtml();
      }
    },
    preview(val) {
      if (val) {
        this.$refs?.builderEditor?.editor.showPreview();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
